<app-loading-spinner *ngIf="appService?.isLoading"></app-loading-spinner>

<div class="contact-container body-content-area">
    <div class="action-area">
        <div class="breadcrumb-area left-align">
            <p><a routerLink="/home"><u>Home</u> </a><span> > </span>
                <a routerLink="/home/contact"><u>Contact</u> </a><span> > </span>
                <span class="heading"> {{operation}} Contact</span> 
                @if (operation!=='add') {
                    <span class="heading">({{dataSource.FirstName+ " "+dataSource.LastName}})</span>
                }
            </p>
        </div>
        <div class="header-area left-align btn-container">
            @if (operation!=='add') {
                <span class="sub-title">{{dataSource.FirstName+ " "+dataSource.LastName }}</span>
            }
            @else {
                <span class="sub-title">New Contact</span>
            }
            <div class="action-bts">
                <button mat-button-primary class="btn white-red-btn" (click)="onbackCall()">Back</button>
                @if (operation!=='view' && userData.RoleID!==3) {
                    @if(operation !="add" && dataSource.Status!== 'Terminated'){
                        @if(dataSource.Status === 'Not Active'){
                        <button class="btn white-red-btn" [ngClass]="contactForm.invalid?'disable-btn':'enable-btn'" (click)="onDelete()">Delete</button>
                        }
                        <button class="btn white-red-btn" [ngClass]="contactForm.invalid?'disable-btn':'enable-btn'" (click)="onCopy()">Copy</button>
                    }
                    <button class="btn red-white-btn" [ngClass]="contactForm.invalid?'disable-btn':'enable-btn'"(click)="onSave()">Save</button>
                }
            </div>
        </div>
    </div>

    <div class="agreement-form-area body-data">
        <div class="agreement-area">
            <form class="form" [formGroup]="contactForm">
                <table class="form-container" cellspacing="0">
                    <tr >
                        <div class="title" style="display: flex;width: fit-content;">Contact Details
                            <!-- <button class="btn green-white-btn">Active</button> -->
                            <button *ngIf="operation !== 'add'" class="btn" [ngClass]="dataSource.Status === 'Not Active'?'amber-white-btn':(dataSource.Status === 'Active'?'green-white-btn':'grey-white-btn')">{{dataSource.Status}}</button>
                        </div>
                    </tr>
                    <tr class="accord-area">
                        <div class="input-item">
                            <label for='contactType' class='required-icon innerLabel'>Contact Type</label>
                            <select formControlName="contactType" (change)="onOptionChange('contactType')"  tabindex="1">
                                <option disabled value="">Select Contact Type</option>
                                <option *ngFor="let option of contactTypeList" [value]="option.LookUpID">
                                    {{ option.LookUpName }}
                                </option>
                            </select>
                        </div>
                        <div class="input-item">
                            <label for='lastName' class='required-icon innerLabel'>Last Name</label>
                            <input type='text' name="lastName" formControlName="lastName" size='50'
                                placeholder="Enter Last Name"  tabindex="1"/>
                        </div>

                        <div class="input-item">
                            <label for='firstName' class='innerLabel'>First Name</label>
                            <input type='text' name="firstName" formControlName="firstName" size='50'
                                placeholder="Enter First Name"  tabindex="1"/>
                        </div>

                        <div class="input-item">
                            <label for='jobTittle' class='innerLabel'>Job Tittle</label>
                            <input type='text' name="jobTittle" formControlName="jobTittle" size='50'
                                placeholder="Enter Job Tittle"  tabindex="1"/>
                        </div>

                        <div class="input-item" [ngClass]="this.operation === 'add'?'enable-field':'disable-field'" (keydown)="onKeyDown($event, this.operation === 'add')">
                            <label for='email' class='required-icon innerLabel'>Email</label>
                            <input type='email' name="email" formControlName="email" size='50'
                                placeholder="Enter Email" [tabindex]="operation === 'add' ? 1 : -1"/>
                        </div>

                        <div class="input-item">
                            <label for='phone' class='innerLabel required-icon'>Phone Number</label>
                            <input type='text' name="phone" formControlName="phone" size='50'
                                placeholder="Enter Phone Number"  tabindex="1"/>
                        </div>

                        <div class="input-item items-2">
                            <label for='notes' class='innerLabel'>Notes</label>
                            <input type='text' name="notes" formControlName="notes" size='50'
                                placeholder="Enter Notes"  tabindex="1"/>
                        </div>

                        <div class="input-item" [ngClass]="this.selectedContactType === '19'?'enable-field':'disable-field'" (keydown)="onKeyDown($event, this.selectedContactType === '19')">
                            <label for='gsdb' class='innerLabel' [ngClass]="this.selectedContactType === '19'?'required-icon':'remove-req-icon'">GSDB</label>
                            <select formControlName="gsdb" (change)="onGsdbSelect($event.target)" (click)="onGSDBUpdate()" [tabindex]="selectedContactType === '19' ? 1 : -1">
                                <option disabled value="">Select GSDB</option>
                                <option *ngFor="let option of gsdbListArr" [value]="option.CarrierID">
                                    {{ option.ContractGSDB}}  <!--+ ' ('+option.Name+')'-->
                                </option>
                            </select>
                        </div>
                        <div class="input-item items-2 disable-field" (keydown)="onKeyDown($event)"> <!--[ngClass]="this.selectedContactType === '19'?'enable-field':'disable-field'"  -->
                            <label for='company' class='innerLabel' [ngClass]="this.selectedContactType === '19'?'required-icon':'remove-req-icon'">Company</label>
                            <input type='text' name="company" formControlName="company" size='50'
                                placeholder="Enter Company" tabindex="-1"/>
                        </div>

                        <!-- <div class="input-item" [ngClass]="this.selectedContactType === '20'?'enable-field':'disable-field'"(keydown)="onKeyDown($event, this.selectedContactType === '20')">
                            <label for='buyerCode' class='innerLabel' [ngClass]="this.selectedContactType === '20'?'required-icon':'remove-req-icon'">Buyer Code</label>
                            <input type='text' name="buyerCode" formControlName="buyerCode" size='50'
                                placeholder="Enter Buyer Code" [tabindex]="selectedContactType === '20' ? 1 : -1"/>
                        </div> -->

                        <div class="input-item" [ngClass]="this.selectedContactType === '20'?'enable-field':'disable-field'"  (keydown)="onKeyDown($event, this.selectedContactType === '20')">
                            <label for='buyerLocation' class='innerLabel' [ngClass]="this.selectedContactType === '20'?'required-icon':'remove-req-icon'">Buyer Location</label>
                            <input type='text' name="buyerLocation" formControlName="buyerLocation" size='50'
                                placeholder="Enter Buyer Location"  [tabindex]="selectedContactType === '20' ? 1 : -1"/>
                        </div>

                        <div class="disable-field input-item" (keydown)="onKeyDown($event)">
                            <label for='createdDate' class='innerLabel'>Created (Date/Time)</label>
                            <input type="text" name="createdDate" formControlName="createdDate" size='50'
                                placeholder="Enter Created Date"  tabindex="-1"/>
                        </div>

                        <div class="disable-field input-item" (keydown)="onKeyDown($event)">
                            <label for='createdBy' class='innerLabel'>Created By</label>
                            <input type='text' name="createdBy" formControlName="createdBy" size='50'
                                placeholder="Enter Created By"  tabindex="-1"/>
                        </div>

                        <div class="disable-field input-item" (keydown)="onKeyDown($event)">
                            <label for='modifiedDate' class='innerLabel'>Modified (Date/Time)</label>
                            <input type="text" name="modifiedDate" formControlName="modifiedDate" size='50'
                                placeholder="Enter Modified Date"  tabindex="-1"/>
                        </div>

                        <div class="disable-field input-item" (keydown)="onKeyDown($event)">
                            <label for='lastModifiedName' class='innerLabel'>Modified Name</label>
                            <input type='text' name="lastModifiedName" formControlName="lastModifiedName" size='50'
                                placeholder="Enter Modified By"  tabindex="-1"/>
                        </div>
                    </tr>
                </table>
            </form>
        </div>
    </div>
</div>